import React from 'react'
import { PeopleFill, People, CircleFill } from 'react-bootstrap-icons'
import moment from 'moment'

const Discussion = ({
    discussion = {},
    onClick = () => {},
    active
}) => {
    const isNew = moment(discussion.lastActiveDate).isBefore(moment(discussion.lastUpdateDate))
    const LeftIcon = isNew ? PeopleFill : People
    return (
        <div
            onClick={() => onClick()}
            style={{
                width: '300px',
                display: 'flex',
                flexDirection: 'row',
                alignItems: 'center',
                alignContent: 'center',
                cursor: 'pointer',
                backgroundColor: active ? 'rgb(236, 242, 255)' : undefined,
                borderRadius: '5px'
            }}
        >
            <div style={{ padding: '5px' }}>
                <LeftIcon color={isNew ? undefined : 'rgb(200, 220, 220)'} />
            </div>
            <div
                style={{
                    width: '290px',
                    whiteSpace: 'nowrap',
                    overflow: 'hidden',
                    textOverflow: 'ellipsis',
                    fontWeight: isNew ? 'bold' : 'normal'
                }}
            >
                {discussion.topic}
            </div>
            <div style={{ padding: '5px', paddingRight: '20px', display: isNew ? undefined : 'none' }}>
                <CircleFill size={10}/>
            </div>
        </div>
    )
}

export default Discussion
